/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Users_TitleInputs */

const cs_settings_users_title = /** @type {(inputs: Settings_Users_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uživatelé`)
};

const en_settings_users_title = /** @type {(inputs: Settings_Users_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Users`)
};

/**
* | output |
* | --- |
* | "Users" |
*
* @param {Settings_Users_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_users_title = /** @type {((inputs?: Settings_Users_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Users_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_users_title(inputs)
	return cs_settings_users_title(inputs)
});